import { websiteRequest } from 'src/editor/shared/utils/request'
import {
  WebsiteThemeInterface,
  WebsiteThemesResponseInterface,
} from 'src/shared/types/website-settings-types'

export const getWebsiteThemes = () =>
  websiteRequest<WebsiteThemesResponseInterface>('themes', 'GET')

export const getWebsiteThemeById = (id: number) =>
  websiteRequest<WebsiteThemeInterface>(`themes/${id}`, 'GET')

export const deleteWebsiteThemeById = (id: number) =>
  websiteRequest(`themes/${id}`, 'DELETE')
